<template>
  <v-row dense :style="$props.vertical ? 'display: grid' : undefined">
    <v-col :cols="$props.cols">
      <v-autocomplete
        v-model="value.category"
        label="Category"
        :items="sortedCategories"
        prepend-inner-icon="mdi-filter-outline"
        item-text="name"
        item-value="id"
        hide-details="auto"
        background-color="input"
        dense
        :clearable="(['pricechopper', 'alliance-retail-group'].includes(tenant) ? isAdminUser : true)"
        outlined>
      </v-autocomplete>
    </v-col>
    <v-col v-if="subcategories.length > 0" :cols="$props.cols">
      <v-autocomplete
        v-model="value.subcategory"
        label="Subcategory"
        :items="subcategories"
        prepend-inner-icon="mdi-filter-outline"
        item-text="name"
        item-value="id"
        hide-details="auto"
        background-color="input"
        dense
        clearable
        outlined>
      </v-autocomplete>
    </v-col>
    <v-col v-if="subtypes.length > 0" :cols="$props.cols">
      <v-autocomplete
        v-model="value.subtype"
        label="Subtype"
        :items="subtypes"
        prepend-inner-icon="mdi-filter-outline"
        item-text="name"
        item-value="id"
        hide-details="auto"
        background-color="input"
        dense
        clearable
        outlined>
      </v-autocomplete>
    </v-col>
    <v-col :cols="$props.cols">
      <v-autocomplete
        label="Status"
        v-model="value.status"
        prepend-inner-icon="mdi-filter-outline"
        :items="statuses"
        item-text="name"
        item-value="id"
        dense
        outlined
        hide-details="auto"
        background-color="input"
        clearable>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>
<script lang="js">
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'DocumentTags',
  mixins: [userAccess, displayAlert],
  props: {
    value: {
      type: [Object, undefined]
    },
    cols: {
      type: [String, Object, undefined],
      default: null
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'value.category'(newValue) {
      if (newValue) {
        this.$gtag.event('filter_apply', {
          category: 'documents',
          filter_type: 'category',
          filter_value: newValue
        })
      }
    },
    'value.subcategory'(newValue) {
      if (newValue) {
        this.$gtag.event('filter_apply', {
          category: 'documents',
          filter_type: 'subcategory',
          filter_value: newValue
        })
      }
    },
    'value.subtype'(newValue) {
      if (newValue) {
        this.$gtag.event('filter_apply', {
          category: 'documents',
          filter_type: 'subtype',
          filter_value: newValue
        })
      }
    },
    'value.status'(newValue) {
      if (newValue) {
        this.$gtag.event('filter_apply', {
          category: 'documents',
          filter_type: 'status',
          filter_value: newValue
        })
      }
    }
  },
  async beforeCreate () {
    try {
      await this.$store.dispatch('getDocumentTags')
    } catch (err) {
      this.handleError(err)
      this.$emit('cancelLoad')
    }
  },
  computed: {
    doc_tags () {
      return this.$store.getters.doc_tags
    },
    sortedCategories() {
      if (this.$auth.tenant === 'alliance-retail-group') {
        return [...this.userCategories].sort((a, b) => a.name.localeCompare(b.name))
      }
      return this.userCategories
    },
    subcategories() {
      if (this.value?.category) {
        const category = this.userCategories.find(c => c?.id === this.value.category)
        if (category?.children?.length > 0) {
          const subcategoryTag = category.children.find(c => c.id === 'SUBCATEGORY')
          const validSubcategories = subcategoryTag?.children?.filter(c => !this.userRestrictedSubcategories.includes(c?.id)) || []
          if (this.$auth.tenant === 'alliance-retail-group') {
            return validSubcategories.sort((a, b) => a.name.localeCompare(b.name))
          }
          return validSubcategories
        }
      }
      return []
    },
    subtypes() {
      if ((this.subcategories?.length > 0) && this.value?.subcategory) {
        const subcategory = this.subcategories.find(s => s.id === this.value.subcategory)
        if (subcategory?.children?.length > 0) {
          const childTag = subcategory.children?.find(c => c.id === 'SUBTYPE')
          return childTag?.children || []
        }
      }
      return []
    },
    statuses () {
      return this.$store.getters.statuses
    }
  }
}
</script>
